'use client'

import dynamic from 'next/dynamic'
import { useGetOrders } from 'order-status-banner/hooks/useGetOrders/useGetOrders'

const OrderStatusBanner = dynamic(() =>
	import(
		'order-status-banner/components/OrderStatusBanner/OrderStatusBanner'
	).then((mod) => mod.OrderStatusBanner)
)

export const OrderStatusBannerContainer = () => {
	const { purchaseDetails, isLoading, isError } = useGetOrders()

	if (!purchaseDetails || isLoading || isError) {
		return null
	}

	return <OrderStatusBanner purchaseDetails={purchaseDetails} />
}
